module.exports = __webpack_public_path__ + "img/bricks.fd306f21.svg";